<template lang="pug">
    .categorypage
        .element(v-if="sections.length" v-for="(section, index) in sections" :key="section.id" :class="section.key")
            Heading(v-if="section.key === 'heading'" :section="section")
            ImageSection(v-if="section.key === 'image'" :section="section")
            Post(v-if="section.key === 'post'" :section="section")
            Slider(v-if="section.key === 'slider'" :section="section")
            CategoryPosts(v-if="section.key === 'categoryposts'" :section="section")
            DividingLine(v-if="section.key === 'dividingLine'" :section="section")

</template>

<script>

// import _ from 'lodash'
import { mapGetters, mapMutations } from 'vuex'

import Heading from '@/components/Heading'
import ImageSection from '@/components/ImageSection'
import Post from '@/components/Post'
import Slider from '@/components/Slider'
import CategoryPosts from '@/components/CategoryPosts'
import DividingLine from '@/components/DividingLine'

export default {
    name: 'CategoryPage',
    components: {
        Heading,
        ImageSection,
        Post,
        Slider,
        CategoryPosts,
        DividingLine
    },
    computed: {
        ...mapGetters({
            sections: 'currentPage/sections',
        })
    },
    methods: {
        ...mapMutations({
            updateHeaderVisibility: 'updateHeaderVisibility',
        })
    },
    mounted() {
        this.updateHeaderVisibility(false)
    }
}

</script>

<style lang="sass" scoped>
    .categorypage
        & > .element
            padding-bottom: 0
            &:first-child
                padding-top: 4.5rem
            &:last-child
                padding-bottom: 4.5rem
            &.category-page-teaser
                display: none
        .element.slider,
        .element.banners
            padding: 0
        .element.heading
            text-transform: initial
</style>
